export default {
    sent: false,
    sending: false,
    careerId: null
};
